

export default function BaseLayout(props) {
  return (
    <div className={props.className}>
      <main style={{padding: '1rem 0'}}>
        {props.children}
      </main>
    </div>
  )
}
